.empty {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 24px;
  text-align: center;
}

.emptyTitle {
  font-size: 18px;
  font-weight: 600;
  color: var(--text);
}

.emptyText {
  max-width: 44ch;
  margin: 8px 0 0;
  font-size: 14px;
  line-height: 1.5;
  color: var(--text2);
}
